export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const HOUR_PX = 72;

export const fmtMin = (m) => {
  if (m === 1440) return "12:00 AM (end of day)";
  const h = Math.floor(m / 60), mm = m % 60;
  return `${((h + 11) % 12) + 1}:${String(mm).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const fmtDur = (s) => {
  s = Math.round(s || 0);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return h ? `${h}h ${m}m` : m ? `${m}m ${sec ? `${sec}s` : ""}`.trim() : `${sec}s`;
};

export const QUARTERS = Array.from({ length: 97 }, (_, i) => i * 15);
